var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DeleteModal',{attrs:{"actions":_vm.getActions.text},on:{"deleteOrder":_vm.deleteOrder,"cancelDel":_vm.canselDel}})}
var staticRenderFns = []

export { render, staticRenderFns }